export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const SUBSCRIBE_PROFILE_TO_LIST = 'SUBSCRIBE_PROFILE_TO_LIST'
